var InputStates = Object.freeze({
  VALIDATED: 'VALIDATED',
  ERROR: 'ERROR',
  HOVERED: 'HOVERED',
  FOCUSED: 'FOCUSED',
  OUT_FOCUSED: 'OUT_FOCUSED',
  DEFAULT: 'DEFAULT'
});
export var ColorStates = Object.freeze({
  VALIDATED: 'green.600',
  ERROR: 'red.500',
  HOVERED: 'blue.200',
  FOCUSED: 'blue.300',
  OUT_FOCUSED: 'grey.200',
  DEFAULT: 'grey.600'
});
export var _getContainerStyles = function _getContainerStyles(_ref) {
  var isFocused = _ref.isFocused,
      isHovered = _ref.isHovered,
      disabled = _ref.disabled,
      error = _ref.error,
      validated = _ref.validated,
      fullWidth = _ref.fullWidth;
  var inputState = error ? InputStates.ERROR : validated ? InputStates.VALIDATED : isFocused ? InputStates.FOCUSED : isHovered ? InputStates.HOVERED : InputStates.OUT_FOCUSED;
  return {
    position: 'relative',
    display: 'inline-block',
    maxWidth: '100%',
    width: fullWidth ? '100%' : 196,
    minHeight: 48,
    maxHeight: 86,
    // to support multine inputs
    pointerEvents: disabled ? 'none' : null,
    '&::after': {
      left: 0,
      right: 0,
      bottom: 0,
      content: '""',
      position: 'absolute',
      transform: "scaleX(1)",
      transition: "all 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
      borderBottomWidth: '2px',
      borderBottomStyle: 'solid',
      borderBottomColor: ColorStates[inputState],
      pointerEvents: 'none'
    }
  };
};